import { z } from 'zod'

// Admin RBAC role. This is the only RBAC signal the front receives: a
// super_admin has tenantId === null and sees every tenant; a tenant_admin is
// confined to its own. Tenant scoping is otherwise invisible (server-side).
export const ADMIN_ROLES = ['super_admin', 'tenant_admin'] as const
export type AdminRole = (typeof ADMIN_ROLES)[number]
export const zAdminRole = z.enum(ADMIN_ROLES)

// Affiliate-link lifecycle. Only `active` links are served to sites; `archived`
// keeps the link (and its conversion history) but stops serving it — always
// prefer archiving over deletion.
export const LINK_STATUSES = ['active', 'archived'] as const
export type LinkStatus = (typeof LINK_STATUSES)[number]
export const zLinkStatus = z.enum(LINK_STATUSES)

// Property / partner `status` is a free string server-side. These document the
// values the UI knows how to tone; unknown values fall back to `neutral` and
// are still rendered verbatim (never dropped).
export const RESOURCE_STATUSES = ['active', 'paused', 'archived', 'disabled'] as const
export type ResourceStatus = (typeof RESOURCE_STATUSES)[number]

// Recognized affiliate networks. NOTE: partnerName is validated as z.string()
// — this list is what the sync jobs recognize and what the UI gives an identity
// dot, but it is NOT enforced. Exact casing matters for the sync jobs.
export const PARTNER_NAMES = ['Kwanko', 'TimeOne', 'Awin', 'MobiMatter', 'Impact'] as const
export type PartnerName = (typeof PARTNER_NAMES)[number]

// Audit-log filters (server-side).
export const AUDIT_RESOURCE_TYPES = ['Property', 'AffiliatePartner', 'AffiliateLink'] as const
export type AuditResourceType = (typeof AUDIT_RESOURCE_TYPES)[number]

export const AUDIT_ACTIONS = ['create', 'update', 'destroy', 'generate_api_key'] as const
export type AuditAction = (typeof AUDIT_ACTIONS)[number]
